import formatRFC3339 from 'date-fns/formatRFC3339';

import keycloakService from '../../keycloak_service';

import { get_list_request } from '../../components/assays/V2Assays/conversions';
import { sinatraOrigin } from '../../config';


const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions)
  .then((response) => {
    if (!response.ok) {
      throw Error(response?.statusText || 'An Unexpected error has occurred.')
    }
    return response.json()
  })

export const fetchAssays = (queryParams) => {
  const [pipeline_id, pipelineName, workspace_id, filterObj, dateObj, isAssaysV2Enabled] = queryParams;
  const params = {
    pipeline_id,
    workspace_id,
  }

  if (filterObj) {
    params.name = filterObj?.name;
    params.active = filterObj?.active;
    params.sort_by = filterObj?.sortBy || 'CreationDateDesc';
    params.drift_detected = filterObj?.driftDetected;
  }

  if (dateObj?.start && dateObj?.end) {
    params.drift_window = {
      start: dateObj?.start ? formatRFC3339(dateObj?.start) : undefined,
      end: dateObj?.end ? formatRFC3339(dateObj?.end) : undefined,
    };
  }

  let body = JSON.stringify(params);
  let path = 'v1/api/assays/filter';
  let method = 'POST';
  /**
   * @deprecated Assays V1 Logic
   */
  if (isAssaysV2Enabled) {
    method = 'POST';
    body = JSON.stringify(get_list_request(pipelineName, filterObj?.active));
    path = 'v2/api/assays/get'
  }

  const fetchOptions = {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body,
  };

  return postToApi(path, fetchOptions)
}

export default fetchAssays;
